export default __webpack_public_path__ + "static/media/Fedex-logo.3c43677d.png";